import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import { Provider } from 'react-redux';

import { ErrorBoundary } from 'features/error-boundary';
import { I18nProvider } from 'features/i18n';
import { LayoutProvider } from 'features/layout';
import { ModalContainer } from 'features/modal';
import { RouterProvider } from 'features/router';
import { ThemeProvider } from 'features/theme';
import { ToastContainer } from 'features/toast';
import { History } from 'history';
import { Store } from 'redux';

export const withProviders = (Component: React.FC, store: Store, history: History): JSX.Element => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <RouterProvider>
        <I18nProvider>
          <ThemeProvider>
            <ErrorBoundary>
              <LayoutProvider>
                <ModalContainer />
                <ToastContainer />
                <Component />
              </LayoutProvider>
            </ErrorBoundary>
          </ThemeProvider>
        </I18nProvider>
      </RouterProvider>
    </ConnectedRouter>
  </Provider>
);
